<template>
     <section class="page-section bg-light" id="gallery">
         
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase" style="color:#ea1e29">Gallery</h2>
          <h3 class="section-subheading text-muted">
            Browse through some of our memories
          </h3>
          <v-col cols="12" sm="14" offset-sm="0">
      
        
          <v-row>
            <div class="container">
        <div class="row">
          <div class="row" >
              <v-card flat tile class="mx-auto " v-for="image in imagesJSON" :key="image"  style="padding-top:10px; background-color:#f8f9fa">
                <v-img
                  :src="image"
                 
                  
                  max-height="200px" max-width="400px"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
          </div></div></div>
          </v-row>
        
      
    </v-col>
        </div>
      
         </div>
     </section>
</template>
<script>
export default {
    data:()=>({
        imagesJSON:[require("../assets/img/gallery/gone.jpg"),require("../assets/img/gallery/gtwo.jpg"),require("../assets/img/gallery/gthree.jpeg"),require("../assets/img/gallery/gfour.jpeg"),require("../assets/img/gallery/gsix.jpeg"),require("../assets/img/gallery/gseven.jpeg")]
    })
}
</script>
<style scoped>

</style>